export function LandingHeader() {
	return (
		<nav className="border-ivory/5 bg-warm-gray/90 fixed top-0 z-50 w-full border-b backdrop-blur-xl">
			<div className="mx-auto max-w-[1400px] px-6 lg:px-12">
				<div className="flex h-20 items-center justify-between">
					<div className="flex items-center gap-4">
						<span className="font-display text-2xl tracking-tight italic">
							findings
						</span>
					</div>
					<div className="hidden items-center space-x-10 text-[11px] font-light tracking-[0.2em] uppercase md:flex">
						<a
							className="hover:text-gold transition-colors"
							href="#"
						>
							Intelligence
						</a>
						<a
							className="hover:text-gold transition-colors"
							href="#"
						>
							Collective
						</a>
						<a
							className="hover:text-gold transition-colors"
							href="#"
						>
							Journal
						</a>
						<a
							className="border-gold/40 hover:bg-gold hover:text-warm-gray border px-6 py-2.5 transition-all duration-300"
							href="#"
						>
							Login
						</a>
					</div>
					<button className="text-ivory md:hidden" type="button">
						<span className="material-symbols-outlined">menu</span>
					</button>
				</div>
			</div>
		</nav>
	);
}
